
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexznI3YyJNIBLMKmk2lpcgYz2x41qA_45Ok_JxdHYwiD4xkMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/index.vue?macro=true";
import { default as login1gBOCE15ErGOmRL6f9zNzdQQK4mLvbKk_45F448JiST3gMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/login.vue?macro=true";
import { default as creategdFLoMoqGJNBT91caK79ej5ZgaAtfTCDHe9WVboVc4kMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgotPRqtS56_qFrlGCKvwdZg37kmGYlmJAcioB4BneYwEqoMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportsFRDDEGEd_H7mTd5liBcqtlWZzobJweWrvBvcF2VfFxUMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45upbWh_rpm8VVhSaO3iGfmT78SqJFkVMMhUnnSab1G6ECgMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insightsHQ3ignfc1a6KB_45LpA4Z6HP5s7J1dIcSu3Mu9dSb77ksMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as new1KFUCkQ_45aTVICwePdU0H_sE425eFIROpIPIh9CxsZM4Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as newVdztJBhHVf81q4Kj0TSdciwyRAqCaKVlWUll6Wt9oDAMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as newQtA4DGLNYphs3LaiY89u6aVAyP8t1jNgD9AzVCNeHW8Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93Pwu3ZpNTmcjXAYdfBIlfMev5IjXsPkNarhOhcLrjHuYMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newJaNEFMO3utLiP_45yWy5ZagsEB2a01KI6hxgj2_45y8KDb4Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_93wplJpMRL3OL_kTs2JMv0vxKSANFS0fYyQOMYYeWJFOsMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newOxlefwU9SFpgsKgL8lebFm3w3hkq0eEmoYH6_xcx1TAMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as indexquc4PJsAic_eSRIkokDVczjP4Ej0HXB3h9U9HEefssIMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_938_456TAjsHH_DpuPz8WZ97jtqOjm0wQ7crWj3HD0qQ91kMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrationsTalyM3MikP4DPq7Zd_ng5vHoWcFoEuDVtkLgGcELJQkMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as indexVAyPn8hkOEkHYKcOc23Q9YKly3FjFMpVB8NwbtvDPHQMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as indexktb6zzqpXsQ1NNMJkQ1kXY4LF5w8Vey3riMcrPG_UIsMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newXDLs0JD__cIoxCdKxPmeasiK9Iyup_t55XatBrDoA2gMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newE5x_45XAWrcCOsucd1Rc8vz4yA1UGXJmEkmfAISaugyncMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexXmyZMoWDU3wPuzVqT_f3DTcpvcq9CJpYsdHhLwPhntYMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_930qTd_RAMNZaqhfMLFTEwIZw6GdVLiIAl5URcbZ0auMIMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as newzNT0kb7oR7IznQ29J6nK6go5yVeLhALlb2vuiVlp4RQMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as newh8webDduxlBMyY09upT4duckFUHCrv1JS1t_IZ83OZ0Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93bFeOjrulZLp8OFAZXtnT1gUOahrhfHQZCD60zLdaNb4Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_93CNNRwpRNY8pnIoFFjgAe7IaBcL2Cqazx25pxhrM90rwMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_93hxUsFrTeERbhCvVzTu6qBENuLCf895772ICSdzzl9RgMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as indexGzTGSKIsNekLkfXG88cz6WI6rD_ldmf4Ye7twSvW9g4Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_93_Da9ksIAIQyN96CFKs4qh3P5PMvPcTpMDn0Z9GyzO24Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93C4jAWnNfs_RFvf00pEyPH3FwBGqxP3gleYfg4NQgOAwMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_937ofMmAmBU_yxfQO2tsDr9_g89EosV1r7sG8ZDvlSrwgMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as download4DxRwrR5tPdrLxN7Gg11aKLUMZLSCHoLE3uSUHCJTYMMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as index2JfSDBwJa5TOdIIdkrkJYoJZ0TXZGmhQVgE1GHhsjPgMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as index2R6HpfljXG4sBOfQE9y_rxPwUma80JwE3_1hSiP9AuUMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as indexx0H2OpRgt8JSCcRo6MVlCrCqzEWPyJT1ytq75Yz6WhsMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as newpi_J_EVugEZnWybJV_459FIafo_459MIpHLQY43qwl9JhL4Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexqhdLFYIHaKqhyeCQlTSNFIwsgnZKFFTTerLhWkbmfnkMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexBmZOA3eGoeOvIhoCqQixgUt6oxu0vbj_45TGdRTrvg07EMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_93xSn2qV_45lXxTsNY1OKJ9BzVriJNjw6miIdSEF3GaEa1IMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as indexmKBkNC5mCO8Ine3bNuJXlhXiv94MvL3BFLrFhoa3xPMMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as indexJzXyJTJqPyzx6sz1gMC65fHMHl321zBcbmlp20JWVRQMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as newcuoJlQ17BWMrhSAf6dCVaWQJQmEvAS4JzM2ScQ2aTtAMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_93tl0UEdfpMVuC5FhHmg0UIWMm6A_45UTbLNsNAJ48avAegMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as indexTAq3QybkFCKcNtaf43G7w8wqR8AApSVwkODdrrbah0gMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as newHVRG6YARRrjCZEt_yJ2OyVgMqqcvpSBOY0kDkOL0hogMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_93Zx3_45oh_Jd__45WEd2_B84wPaDv3HI8U3pUtSL98BJiQdQMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indexYyxGhghWp_hnh4vgsfKsHlfstBCiHPx3U9XjqNFP7YAMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as new0EX15qr05xVfnu3L70WUIfewX4Le4eqA79OZvSAg_45toMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_93TE16Oy0oOG_x21U8Rq07rvjI9JL5cnIc9vY6h4flKl0Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as indexwHIizxTeV7Mj4WSu9LuviE4GVASu71RRHIWhQqCf2lQMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_93hqvD3EUZDCCrlPz4kERrtKiNFx9mpa5e7w1Io3_IdBMMeta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45historyhAazD6qnOMv8HUVBXiNJC3KNfJqaikf3Mhm_45CItxB48Meta } from "/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src1760905442/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]